module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageAdmin.svg?c4120382";